export default function HeroBanner() {
    return (
        <div className="max-w-full w-[1200px] mx-auto my-16">
            <div className="md:space-y-0 md:space-x-4 flex items-center space-y-5 px-6">
                <div className="md:w-7/12 text-left space-y-8">
                    <h1 className="md:text-[67px] md:leading-[80px] text-4xl font-bold text-[#1e1e1e]">
                        <span className="olm-gradient-text">Get Started</span>
                        <br />
                        <span>with Direct Mail</span>
                    </h1>
                    <img
                        src="/assets/get-started/hero-banner-mobile.webp"
                        alt="Get started banner"
                        className="md:hidden block"
                    />
                    <div className="space-y-4 text-[#444241]">
                        <p className="md:text-2xl/normal text-lg font-bold">
                            Welcome to Your Direct Mail Journey
                        </p>
                        <p className="md:text-xl/normal text-lg font-medium">
                            Starting out with direct mail? You&apos;re in the
                            right place. We&apos;re all about making it easy and
                            effective for you to reach your audience through
                            physical mail. No fluff, just the essentials to get
                            you going.
                        </p>
                    </div>
                    <a
                        className="sm:w-[22rem] w-full inline-block"
                        href="#dive-deeper">
                        <button className="sm:w-[22rem] w-full font-semibold olm-gradient px-10 py-5 rounded shadow text-center text-[#fffbf9] text-xl/6">
                            Let&apos;s Go
                        </button>
                    </a>
                </div>
                <div className="md:w-5/12 md:block h-full hidden">
                    <img
                        src="/assets/get-started/hero-banner.webp"
                        alt="A smiling man in a denim shirt and glasses is holding a tablet, with two small circular profile pictures of other smiling professionals overlaid on a bright orange background."
                        title="Professional man working with digital collaboration."
                    />
                </div>
            </div>
        </div>
    )
}
